exports = module.exports = require("../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".bc-tag > span > span {\n  float: left;\n  display: block;\n}\n", ""]);

// exports
